/* import __COLOCATED_TEMPLATE__ from './bot-inbox-settings.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export default class BotInboxSettings extends Component {
  @service appService;
  @service intl;

  get assignToBotInboxText() {
    return this.intl.t(
      'operator.settings.turn-on-bot-inbox-channel.assign-to-bot-inbox-text-deferred-actions',
      { htmlSafe: true },
    );
  }
}
